import styles from './styles.module.scss'

const Header = (): JSX.Element => (
  <header className={styles.header}>
    <div className={`${styles.content} ${styles.navigation}`}>
      <div className={styles.logoLink}>
        <img
          className={styles.logo}
          src="/partner-introduction/ecbo-cloak-logo.png"
          alt="ecbo cloak"
        />
      </div>
      <nav className={styles.navigationCta} aria-label="ページ内ナビゲーション">
        <a href="#docs" className={styles.navigationLink}>
          サービス資料
        </a>
        <a href="#faq" className={styles.navigationLink}>
          よくある質問
        </a>
        <a
          href="#form"
          className={`${styles.button} ${styles.primaryButton} ${styles.headerButton}`}
        >
          紹介する
        </a>
      </nav>
    </div>
  </header>
)

export default Header
